<template>
  <div
    :class="{ 'text-left': compressed }"
    v-bind="
      includeProps
        ? {
            itemprop: 'offers',
            itemtype: 'https://schema.org/Offer',
            itemscope: 'itemscope'
          }
        : {}
    "
  >
    <link
      v-if="includeProps && stock && stock.is_enabled && stock.is_in_stock"
      itemprop="availability"
      href="https://schema.org/InStock"
    />
    <link
      v-else-if="includeProps"
      itemprop="availability"
      href="https://schema.org/OutOfStock"
    />
    <PriceCrossed
      v-if="showStrikePrice && price.savings"
      class="l-height-19"
      :class="{
        'font-size-m': compressed,
        'font-size-l': !compressed,
        'pb-2': !noMargin
      }"
      :original-price="price.originalPrice"
      :loading="loading"
    />
    <div class="price-info d-flex align-center" :class="{ 'pb-2': !noMargin }">
      <time
        v-if="includeProps && price.validUntil"
        itemprop="priceValidUntil"
        :datetime="price.validUntil"
      ></time>
      <link
        v-if="includeProps"
        itemprop="itemCondition"
        itemtype="https://schema.org/itemCondition"
        href="https://schema.org/NewCondition"
      />
      <div v-if="!compressed && showDiscount && price.savings">
        <DiscountFlag class="mr-1" :loading="loading" :text="price.savings" />
      </div>
      <div
        class="final-price text-no-wrap"
        :loading="loading"
        :class="{
          'l-height-19': compressed
        }"
        :style="{ fontWeight: '600' }"
      >
        <span
          :itemprop="includeProps ? 'price' : null"
          :content="includeProps ? price.finalPrice : null"
          v-html="price.finalPriceFormatted"
          :loading="!price.finalPriceFormatted"
        ></span>
        <meta
          v-if="includeProps"
          itemprop="priceCurrency"
          :content="price.currency"
        />
        <span
          v-if="showStar"
          v-show="price.finalPriceFormatted && price.finalPrice"
          class="c-clay"
        >
          *</span
        >
      </div>
    </div>
    <PricePerUnit
      v-if="price.showUnitPrice && price.unitPrice"
      class="price-per-unit"
      :class="{ 'c-gray': compressed }"
      :loading="loading"
      :formatted="price.unitPrice"
    />
    <span
      class="ppu-dummy"
      v-if="!price.finalPriceFormatted"
      :loading="!price.finalPriceFormatted"
    ></span>
  </div>
</template>

<script>
import PriceCrossed from '@/components/basic/atoms/PriceCrossed.vue'
import PricePerUnit from '@/components/basic/atoms/PricePerUnit.vue'
import PriceObject from '@/modules/PriceObject'
import { defineAsyncComponent } from 'vue'

const DiscountFlag = defineAsyncComponent(
  () => import('@/components/basic/atoms/DiscountFlag.vue')
)

export default {
  name: 'Price',
  components: { DiscountFlag, PricePerUnit, PriceCrossed },
  props: {
    loading: Boolean,
    price: [PriceObject, Object],
    stock: Object,
    showStrikePrice: {
      default: true,
      type: Boolean
    },
    showDiscount: {
      default: true,
      type: Boolean
    },
    includeProps: {
      default: false,
      type: Boolean
    },
    compressed: {
      default: false,
      type: Boolean
    },
    noMargin: {
      default: false,
      type: Boolean
    },
    showStar: {
      default: true,
      type: Boolean
    }
  }
}
</script>

<style scoped>
.final-price span[loading='true'] {
  min-width: 50px;
  min-height: 26px;
  display: inline-flex;
  margin-top: 0.5rem;
}
.ppu-dummy {
  min-width: 60px;
  min-height: 13px;
  display: inline-flex;
}
</style>
